var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTtdInfoCoinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.068 24.0208C17.5784 24.0208 21.2347 20.3645 21.2347 15.8542C21.2347 11.3438 17.5784 7.6875 13.068 7.6875C8.55771 7.6875 4.90137 11.3438 4.90137 15.8542C4.90137 20.3645 8.55771 24.0208 13.068 24.0208Z",
    fill: "#D1D9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2673 24.0208C14.7776 24.0208 18.4339 20.3645 18.4339 15.8542C18.4339 11.3438 14.7776 7.6875 10.2673 7.6875C5.75693 7.6875 2.10059 11.3438 2.10059 15.8542C2.10059 20.3645 5.75693 24.0208 10.2673 24.0208Z",
    fill: "white",
    stroke: "#4258BF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5498 17.7554C7.5498 18.8089 8.3583 19.6582 9.3628 19.6582H11.4126C12.2865 19.6582 12.997 18.915 12.997 18.0004C12.997 17.004 12.5641 16.6529 11.919 16.4242L8.6278 15.2809C7.98264 15.0522 7.5498 14.701 7.5498 13.7047C7.5498 12.79 8.2603 12.0469 9.13414 12.0469H11.184C12.1885 12.0469 12.997 12.8962 12.997 13.9497",
    stroke: "#4258BF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2676 10.9531V20.7531",
    stroke: "#4258BF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0544 5.37214L21.584 3.25391L22.1135 5.37212L23.4649 4.87299L22.9657 6.22434L25.084 6.75391L22.9657 7.28347L23.4649 8.6348L22.1135 8.13566L21.584 10.2539L21.0544 8.13564L19.7031 8.6348L20.2022 7.28346L18.084 6.75391L20.2022 6.22435L19.7031 4.87299L21.0544 5.37214Z",
    fill: "#D1D9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0666 10.1225L24.3844 8.85156L24.7021 10.1225L25.5129 9.82301L25.2134 10.6338L26.4844 10.9516L25.2134 11.2693L25.5129 12.0801L24.7021 11.7806L24.3844 13.0516L24.0666 11.7806L23.2558 12.0801L23.5553 11.2693L22.2844 10.9516L23.5553 10.6338L23.2558 9.82301L24.0666 10.1225Z",
    fill: "#D1D9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtdInfoCoinIcon);
export default __webpack_public_path__ + "static/media/ttd-info-coin-icon.baf16a65d8e3c24a991c814d59872954.svg";
export { ForwardRef as ReactComponent };